import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

const FULL_ADMIN_EMAILS = new Set([
  "andyvc00@hotmail.com",
  "jeanjen.confirmph@gmail.com",
]);

/**
 * Role gate.
 *   <RequireRole role="platform_admin"> → only super admin
 *   <RequireRole role="promoter">       → only registered promoter
 */
export default function RequireRole({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-500"
            data-testid="role-auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const accountType = user.account_type || user.role;
  const hasFullAdminAccess = FULL_ADMIN_EMAILS.has((user.email || "").toLowerCase());
  if (accountType !== role || (role === "platform_admin" && !hasFullAdminAccess)) {
    // Send everyone to their "home" surface so they can never see the
    // wrong dashboard.
    if (accountType === "customer") return <Navigate to="/portal" replace />;
    if (accountType === "platform_admin") return <Navigate to="/" replace />;
    if (accountType === "promoter") return <Navigate to="/promoter" replace />;
    return <Navigate to="/app" replace />;
  }
  return children;
}
